<template>
	<div
		:class="
			cn(
				propertyCardBodyVariants({ variant }),
				skeletonVariant === 'white'
					? 'border-white-dark-2'
					: 'border-primary-light-4'
			)
		"
	>
		<Skeleton
			:is-active="true"
			:variant="skeletonVariant"
			:class="propertyCardHeaderBodyVariants({ variant })"
		/>
		<div
			:class="cn(propertyCardFooterBodyVariants({ variant }), '!border-none')"
			class="flex flex-col gap-2"
		>
			<div>
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
			</div>

			<div class="flex items-center gap-2">
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
				<Skeleton :is-active="true" :variant="skeletonVariant" class="size-1" />
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
				<Skeleton :is-active="true" :variant="skeletonVariant" class="size-1" />

				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
			</div>
			<div class="flex items-center gap-2">
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[85%]"
				/>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
import {
	propertyCardBodyVariants,
	propertyCardContentVariants,
	propertyCardFooterBodyVariants,
	propertyCardHeaderBodyVariants,
	type PropertyCardBodyVariants
} from '.';
import { Skeleton } from '../ui/skeleton';
import { cn } from '@/utils';

const props = defineProps<{
	variant: PropertyCardBodyVariants['variant'];
}>();

const skeletonVariant = computed(() => {
	if (props.variant === 'whiteBackground') return 'white';
	return 'primary';
});
</script>
